import { SortDescriptor } from '@progress/kendo-data-query';
import { UDViewTagSelectionEnum } from '../../../udView/udview';
import { dashboardFlightFilters } from '../../utils/dashboard';
import { DashboardCustomColumn, DashboardFlightColumn, DashboardFlightsPanel } from './DashboardFlightsPanel';

const columns: DashboardFlightColumn[] = [
    { id: 'acid', field: 'normalizedAcid', title: 'Aircraft ID', tagSelector: UDViewTagSelectionEnum.Acid },
    { id: 'acType', field: 'aircraftType', title: 'ACType', tagSelector: UDViewTagSelectionEnum.AircraftType },
    { id: 'origin', field: 'origin', title: 'Origin', tagSelector: UDViewTagSelectionEnum.Origin },
    { id: 'destination', field: 'destination', title: 'Dest', tagSelector: UDViewTagSelectionEnum.Destination },
    { id: 'altitude', field: 'altitude', title: 'Altitude', tagSelector: UDViewTagSelectionEnum.Altitude }
];

const customColumns: DashboardCustomColumn[] = [
    { id: 'enteredHold', field: 'enteredHold', title: 'Entered Hold' },
    {
        id: 'holdTime',
        field: 'holdTime',
        title: 'Hold Time'
    }
];

const defaultSort: SortDescriptor[] = [{ field: 'holdTime', dir: 'desc' }];

export function HoldingFlightsList() {
    return (
        <DashboardFlightsPanel
            title="Holding flights"
            flightFilters={dashboardFlightFilters.holding}
            columns={columns}
            customColumns={customColumns}
            defaultSort={defaultSort}
            variant="holding"
            emptyText="No holding flights"
        />
    );
}
